import {
    getEbikeTrackerStatus,
    activateEbikeTracker,
} from "../../api/biketrax";

const getDefaultState = () => {
    return { all: {}, contractsCounter: 0 };
};

const state = getDefaultState();

const getters = {};

const actions = {
    getEbikeTrackerStatus({ commit, state }, payload) {
        if (!(payload.vertragsnummer in state.all)) {
            commit("setLoading", true, { root: true });
        }
        getEbikeTrackerStatus(payload).then((response) => {
            if (response.data.Status === 200) {
                commit("setDetails", {
                    contractId: payload.vertragsnummer,
                    result: response.data.Result,
                });
            }
        });
    },
    activateEbikeTracker({ commit }, payload) {
        return new Promise((resolve) => {
            commit("setLoading", true, { root: true });
            activateEbikeTracker(payload).then((response) => {
                if (response.data.Status === 200) {
                    commit("setDetails", {
                        contractId: payload.vertragsnummer,
                        result: response.data.Result,
                    });
                    resolve();
                }
            });
        });
    },
};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setDetails(state, payload) {
        state.all = {
            ...state.all,
            [payload.contractId]: payload.result,
        };
    },
    setContractsCounter(state, counter) {
        state.contractsCounter = counter;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
